"use client";

export default function ErrorBoundary({ reset }: { reset: () => void }) {
  return (
    <main className="page-shell">
      <div className="container narrow center">
        <p className="eyebrow">Error</p>
        <h1>Terjadi masalah saat memuat halaman.</h1>
        <p>Silakan coba lagi dalam beberapa saat.</p>
        <button type="button" className="button-primary" onClick={() => reset()}>
          Coba lagi
        </button>
      </div>
    </main>
  );
}
